module.exports = __webpack_public_path__ + "static/media/facebook.6ff22232.png";